import React from "react";
import { Table, Typography } from "antd";
import dayjs from "dayjs";
import { nebulisationDoseOptions } from "../../../IpEMR/Options/careItemsOptions";

const { Paragraph } = Typography;

const Nebulization = ({ details }) => {
  const nebulization = details?.data?.nebulization;
  // console.log(nebulization, "nnnnnnnnnnnnnnnnnnn");

  const columns = [
    {
      title: "Started On",
      dataIndex: "action_time",
      key: "action_time",
      render: (value) => dayjs(value)?.format("DD, MMM hh:mm A"),
    },
    {
      title: "Name + Dose",
      dataIndex: "drug_name",
      key: "drug_name",
      render: (value) =>
        nebulisationDoseOptions?.find((option) => option.value === value)
          ?.label || "-",
    },
    {
      title: "Frequency",
      dataIndex: "frequency",
      key: "frequency",
      render: (_, record) => record?.data?.do_data?.frequency,
    },
    {
      title: "Comments",
      dataIndex: "comments",
      key: "comments",
      render: (value, record) =>
        record?.data?.do_data?.notes ? (
          <Paragraph
            ellipsis={{
              rows: 2,
              expandable: true,
              symbol: "more",
            }}
            style={{
              width: "100%",
              maxWidth: "100%",
              marginBottom: 0,
              whiteSpace: "normal",
              wordBreak: "break-word",
            }}
          >
            {record?.data?.do_data?.notes}
          </Paragraph>
        ) : (
          "-"
        ),
    },
  ];
  return (
    <Table dataSource={nebulization} pagination={false} columns={columns} />
  );
};

export default Nebulization;
